import { memo, useState } from "react";
import { InfoModal } from "../Modal/InfoModal";
import { Button } from "../Button/Button";
import { VarianButtonEnum } from "../../enum/Button/variantButton.model";
import { IconModelEnum } from "../../enum/Button/iconButton.model";
import classNames from "classnames";

const INFO_CLOSE_MS = 700;

export const InfoShield = memo(() => {
  const [isInfoOpen, setIsInfoOpen] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoLeaving, setInfoLeaving] = useState(false);

  const openInfo = () => {
    setIsInfoOpen(true);
    setShowInfoModal(true);
  };

  const closeInfo = () => {
    setIsInfoOpen(false);
    setInfoLeaving(true);
    setTimeout(() => {
      setShowInfoModal(false);
      setInfoLeaving(false);
    }, INFO_CLOSE_MS);
  };

  return (
    <>
      <div className="fixed bottom-[140px] left-[1%] z-50">
        <div className="relative h-[45px] !w-[45px] [perspective:1000px]">
          <div
            className={classNames(
              "absolute inset-0 transition-all duration-700 ease-in-out [backface-visibility:hidden]",
              {
                "opacity-100 scale-100 rotate-y-0 pointer-events-auto": !isInfoOpen,
                "opacity-0 scale-95 [transform:rotateY(180deg)] pointer-events-none": isInfoOpen,
              }
            )}
          >
            <Button
              variant={VarianButtonEnum.PRIMARY}
              onClickEvent={openInfo}
              customClassNames="h-[45px] !w-[45px] rounded-xl"
              icon={IconModelEnum.InfoFilled}
            />
          </div>

          <div
            className={classNames(
              "absolute inset-0 transition-all duration-700 ease-in-out [backface-visibility:hidden]",
              {
                "opacity-100 scale-100 [transform:rotateY(0deg)] pointer-events-auto": isInfoOpen,
                "opacity-0 scale-95 [transform:rotateY(-180deg)] pointer-events-none": !isInfoOpen,
              }
            )}
          >
            <Button
              variant={VarianButtonEnum.PRIMARY}
              onClickEvent={closeInfo}
              customClassNames="h-[45px] !w-[45px] pr-px rounded-full"
              icon={IconModelEnum.BigClose}
            />
          </div>
        </div>
      </div>
      {showInfoModal && (
        <InfoModal
          setIsInfoOpen={(open: boolean) => {
            if (open) openInfo();
            else closeInfo();
          }}
          infoLeaving={infoLeaving}
        />
      )}
    </>
  );
});

InfoShield.displayName = "InfoShield";